import React, { useState } from 'react'
import { NavLink } from 'react-router'
import { Navbar, Nav, Container, Button } from 'react-bootstrap'
import IconWithTooltip from '@/components/shared/IconWithTooltip'
import UserMenu from '@/components/UserMenu'
import ContactUsModal from '@/components/ContactUsModal'
import VerticalSeparator from '@/components/shared/VerticalSeparator'
import './AppNavbar.scss'
import { ProjectType } from '@/features/apiSliceWithProjects'
import { userCurrentUser } from '@/features/apiSliceWithCurrentUser'

export default function AppNavbar() {
  const currentUser = userCurrentUser()
  const [showContactUsModal, setShowContactUsModal] = useState(false)
  return (
    <Navbar bg="light" expand="lg" className="mb-3 border-bottom" sticky="top">
      <Container className="flex-nowrap gap-2">
        <Navbar.Brand className="mb-1 text-primary fw-bold flex-shrink-0">
          <img src="/brand.png" alt="Samsechoes" height="75" />
        </Navbar.Brand>
        <div
          className="d-flex flex-nowrap align-items-center flex-grow-1 ms-2"
          style={{ minWidth: 0 }}
        >
          <div
            className="d-flex flex-nowrap align-items-center gap-2 gap-lg-3 flex-grow-1 overflow-hidden"
            style={{ minWidth: 0 }}
          >
            {currentUser &&
              <>
                <Nav.Link as={NavLink} to="/projects">
                  <IconWithTooltip icon={'fa-solid fa-list-dots'}
                                   tooltip="Show echoes where you are invited" />
                </Nav.Link>
                <Nav.Link as={NavLink} to={`/projects?projectType=${ProjectType.Managed}`}>
                  <IconWithTooltip icon={'fa-solid fa-pen-to-square'}
                                   tooltip="Edit your echoes where you have editor access" />
                </Nav.Link>
                {currentUser?.role === 'admin' && (
                  <>
                    <VerticalSeparator />
                    <Nav.Link as={NavLink} to={`/projects?projectType=${ProjectType.Admin}`}>
                      <IconWithTooltip icon={'fa-solid fa-toolbox'} tooltip="Admin page" />
                    </Nav.Link>
                    <Nav.Link as={NavLink} to="/projects/new">
                      <IconWithTooltip icon={'fa-solid fa-plus'} tooltip="Create new echo" />
                    </Nav.Link>
                    <VerticalSeparator />
                    <Nav.Link as={NavLink} to="/portals">
                      <IconWithTooltip icon={'fa-solid fa-clipboard-check'} tooltip="Show portals" />
                    </Nav.Link>
                    <Nav.Link as={NavLink} to="/portals/new">
                      <IconWithTooltip icon={'fa-solid fa-file-pen'} tooltip="Create new portal" />
                    </Nav.Link>
                    <VerticalSeparator />
                  </>
                )}
              </>
            }
          </div>
          <div className="d-flex flex-nowrap align-items-center gap-2 gap-lg-3 ms-auto ps-2 flex-shrink-0">
            <Nav.Link as={NavLink} to="https://www.samsechoes.com/" target="_blank" rel="noopener noreferrer">
              <IconWithTooltip icon={'fa-solid fa-circle-info'} tooltip="Blog" />
            </Nav.Link>
            {currentUser &&
              <Button variant="link" onClick={() => setShowContactUsModal(true)}>
                <IconWithTooltip icon={'fa-solid fa-envelope'} tooltip="Contact us" />
              </Button>
            }
            <UserMenu />
          </div>
        </div>
      </Container>
      <ContactUsModal
        show={showContactUsModal}
        onClose={() => setShowContactUsModal(false)}
      />
    </Navbar>
  )
}
